'use client'
import React from 'react';
import { useRouter } from 'next/navigation';

const HeaderLogo = () => {
  const router = useRouter();

    const handleLogoClick = () => {
        router.push('/');
    };

    return (
        <div 
            className="flex min-w-0 shrink-0 cursor-pointer items-center gap-2 transition-opacity hover:opacity-80 sm:gap-3"
            onClick={handleLogoClick}
        >
            <div className="relative flex-shrink-0 flex items-center">
                <img
                    src="/idx-perps-logo-secondary-orderly.webp"
                    alt="IDX Logo Transparent Background"
                    width={48}
                    height={48}
                    decoding="async"
                    fetchPriority="high"
                    className="pointer-events-none h-9 w-9 select-none object-contain sm:h-11 sm:w-11 lg:h-12 lg:w-12"
                />
            </div>
            <div className="min-w-0 hidden md:block">
                <span className="block text-base sm:text-lg lg:text-xl font-bold text-white tracking-tight">
                    IDX AutoBot
                </span>
            </div>
        </div>
    );
} 
export default HeaderLogo;
